import React, { useRef, useEffect } from 'react';
import * as oauth from '../oauth.js';

const CLIENT_ID = "8896805571";

const TelegramLoginButton = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const callbackName = "__tg_oauth_cb_" + Date.now();
    window[callbackName] = (data) => {
      console.log('TG OAuth callback data:', data);
      if (data) {
        oauth.TelegramLoginWidgetAuth({
          tgData: data,
          onJWTObtained: () => {
            window.location.href = '/';
          }
        }).catch((err) => {
          console.error('TG OAuth auth failed:', err);
        });
      }
      delete window[callbackName];
    };

    const script = document.createElement("script");
    script.src = "https://oauth.telegram.org/js/telegram-login.js?5";
    script.setAttribute("data-client-id", CLIENT_ID);
    script.setAttribute("data-onauth", callbackName + "(user)");
    script.setAttribute("data-request-access", "write");
    script.setAttribute("data-size", "medium");
    script.async = true;
    script.onerror = () => console.error("Failed to load Telegram OAuth script");
    script.onload = () => console.log("Telegram OAuth script loaded");

    containerRef.current.innerHTML = "";
    containerRef.current.appendChild(script);

    return () => { delete window[callbackName]; };
  }, []);

  return <div ref={containerRef} style={{ minHeight: 40 }} />;
};

export default TelegramLoginButton;
